// A heartbeat belongs to the exact browser session which dispatched it.
// A newer login, BU selection, logout or unmount makes its response obsolete.
export function createSessionRefreshController({ readToken, requestSession, onResponse }) {
  let disposed = false;
  let activeRequest = null;

  const refresh = async () => {
    const token = readToken();
    if (disposed || activeRequest || !token) return;
    const controller = new AbortController();
    activeRequest = controller;
    try {
      const response = await requestSession(controller.signal);
      if (disposed || controller.signal.aborted || readToken() !== token) return;
      onResponse(response);
    } catch (_error) {
      // The shared response interceptor handles revoked/expired sessions.
    } finally {
      if (activeRequest === controller) activeRequest = null;
    }
  };

  return {
    refresh,
    dispose() {
      disposed = true;
      activeRequest?.abort();
    },
  };
}
